import { type Entity, type SparePartEntity } from '../../../apis/ilink.type';
import {
  type ServiceWorkshop,
  type SparePartWorkshop,
  type ServicesBillingTypeBody,
  type SparePartsBillingTypeBody,
} from '../../../apis/interventions/intervention.type';
import { findSelectedArticle } from '../../../business/articleHelper';

type PogoKey = keyof typeof POGOS;
type PogoItem = (typeof POGOS)[PogoKey];

export const POGOS = {
  WARRANTY: { workshopId: 2, masterdataId: 'GARANTI', label: 'intervention.pogo.label.warranty' },
  PAYING: { workshopId: 3, masterdataId: 'PAYANT', label: 'intervention.pogo.label.paying' },
  OFFERED: { workshopId: 4, masterdataId: 'OFFERT', label: 'intervention.pogo.label.offered' },
  OGEA: { workshopId: 5, masterdataId: 'ASSURANCE OGEA', label: 'intervention.pogo.label.ogea' },
  INTERNAL: { workshopId: 6, masterdataId: 'INTERNAL', label: 'intervention.pogo.label.internal' },
} as const;

export function getPogoFromWorkhopId(workshopId: number): PogoItem | undefined {
  return Object.values(POGOS).find(pogo => pogo.workshopId === workshopId);
}

export const hasFullWarranty = (items: (ServiceWorkshop | SparePartWorkshop)[] | undefined = []) =>
  items.every(item => item.pogoId === POGOS.WARRANTY.workshopId);

export const mapSparePartEntityToPogo = (sparePart: SparePartEntity): SparePartsBillingTypeBody => {
  const pogoId = sparePart.articles.find(findSelectedArticle)?.pogoId ?? null;

  const selectedArticle = sparePart.articles.find(findSelectedArticle);

  return {
    currentPogoId: null,
    pogoId,
    quantity: sparePart.quantity,
    sparePartCode: selectedArticle?.articleId ?? sparePart.articles[0].articleId,
    orderNumbers: sparePart.orderNumbers,
  };
};

export const mapSparePartEntityToPogoWithExistingQuantity = (
  addedSparePart: SparePartEntity,
  existingSpareParts: SparePartEntity[]
): SparePartsBillingTypeBody => {
  const addedArticleId = addedSparePart.articles.find(findSelectedArticle)?.articleId;
  const existingQuantity = existingSpareParts
    .filter(sparePart => sparePart.articles.find(findSelectedArticle)?.articleId === addedArticleId)
    .reduce((total, sparePart) => total + sparePart.quantity, 0);

  return { ...mapSparePartEntityToPogo(addedSparePart), quantity: existingQuantity + addedSparePart.quantity };
};

export const mapServiceEntityToPogo = (service: Entity): ServicesBillingTypeBody => {
  const pogoId = service.articles.find(findSelectedArticle)?.pogoId ?? null;

  return { currentPogoId: null, pogoId, quantity: service.quantity, serviceModelCode: service.modelCode };
};
